module.exports = __webpack_public_path__ + "img/install-app-onelink.627a5fcf.png";